<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
              variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <v-tabs class="mt-3" v-model="current_tab" color="primary-dark" centered>
              <v-tab value="tab-epr">
                <v-icon>mdi-calendar-blank-outline</v-icon>
                L'épreuve
              </v-tab>
              <v-tab value="tab-ins">
                <v-icon>mdi-account-plus-outline</v-icon>
                Le module d'inscription
              </v-tab>
              <v-tab value="tab-cou">
                <v-icon>mdi-run</v-icon>
                Les courses
              </v-tab>
            </v-tabs>
            <v-window v-model="current_tab">
              <v-window-item value="tab-epr">
                <v-card>
                  <v-card-text>
                    <ConfigEvenement></ConfigEvenement>
                  </v-card-text>
                </v-card>
              </v-window-item>
              <v-window-item value="tab-ins">
                <v-card>
                  <v-card-text>
                    <ConfigModule></ConfigModule>
                  </v-card-text>
                </v-card>
              </v-window-item>
              <v-window-item value="tab-cou">
                <v-card>
                  <v-card-text>
                    <ConfigCourses></ConfigCourses>
                  </v-card-text>
                </v-card>
              </v-window-item>
            </v-window>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ConfigEvenement from "@/components/Administration/ConfigurationModule/Config_Evenement.vue";
import ConfigModule from "@/components/Administration/ConfigurationModule/Config_Module.vue";
import ConfigCourses from "@/components/Administration/ConfigurationModule/Config_Courses.vue";
export default {
  components: { ConfigEvenement, ConfigModule, ConfigCourses },
  data() {
    return {
      current_tab: "tab-epr",
    };
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped></style>